import { render, staticRenderFns } from "./infoCenter.vue?vue&type=template&id=0ac77a8f"
import script from "./infoCenter.vue?vue&type=script&lang=js"
export * from "./infoCenter.vue?vue&type=script&lang=js"
import style0 from "./infoCenter.vue?vue&type=style&index=0&id=0ac77a8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports